module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/main-view-cloud_5c1f498bcc26aee20e73178ccfc87072.png";